/* tslint:disable */
import { ViewSelect } from './view-select';

/**
 */
export class StartCalcul {
    precisionlogstep?: number;
    idStudy?: number;
    epsilonTemp?: number;
    epsilonEnth?: number;
    nbOptimIter?: number;
    timeStep?: number;
    precision?: number;
    scheckStorage?: number;
    storagestep?: number;
    hRadioOn?: number;
    hRadioOff?: number;
    maxIter?: number;
    relaxCoef?: number;
    vRadioOn?: number;
    vRadioOff?: number;
    tempPtSurf?: number;
    tempPtIn?: number;
    tempPtBot?: number;
    tempPtAvg?: number;
    idStudyEquipment?: number;
    select1?: ViewSelect[];
    select2?: ViewSelect[];
    select3?: ViewSelect[];
    select4?: ViewSelect[];
    select5?: ViewSelect[];
    select6?: ViewSelect[];
    select7?: ViewSelect[];
    select8?: ViewSelect[];
    select9?: ViewSelect[];
    seValue1?: number;
    seValue2?: number;
    seValue3?: number;
    seValue4?: number;
    seValue5?: number;
    seValue6?: number;
    seValue7?: number;
    seValue8?: number;
    seValue9?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/start-calcul.ts